import { animate, state, style, transition, trigger } from '@angular/animations';
import { CurrencyPipe, DOCUMENT, NgFor, NgIf, SlicePipe, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, OnInit, Optional, PLATFORM_ID, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Response } from 'express';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { CommonComponent } from 'src/app/common/common/common.component';
import { CardSearchAtecoComponent } from 'src/app/common/components/card-search-ateco/card-search-ateco.component';
import { SearchBarInputComponent } from 'src/app/common/components/search-bar-input/search-bar-input.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConsoleLoggerService } from 'src/app/services/console-logger.service';
import { ShareService } from 'src/app/services/share.service';
import { environment } from 'src/environments/environment';

import { RESPONSE } from '../../../server.token';
import {
  AgencySearch,
  AgencyService,
  AgentSearch,
  AgentService,
  GenericRequestService,
  Listing,
  ListingSearch,
  ListingService,
  MemberService,
  MutuiConfig,
  ProfessionistSearch,
  ProfessionistService,
  UserSearch,
  UserSearchService,
} from '../../api';
import '../../app.component';
import { AppComponent } from '../../app.component';
import { BrandBannerComponent } from '../../common/components/brand-components/brand-banner/brand-banner.component';
import { CardSearchAgenteComponent } from '../../common/components/card-search-agente/card-search-agente.component';
import { CardSearchAgenziaComponent } from '../../common/components/card-search-agenzia/card-search-agenzia.component';
import {
  CardRicercheRecentiComponent
} from '../../common/components/card-search-annunci-recenti/card-search-annunci-recenti.component';
import { CardSearchAnnuncioComponent } from '../../common/components/card-search-annuncio/card-search-annuncio.component';
import {
  CardSearchProfessionistaComponent
} from '../../common/components/card-search-professionista/card-search-professionista.component';
import { FooterComponent } from '../../common/components/footer/footer.component';
import { HeaderComponent } from '../../common/components/header/header.component';
import { LoadingComponent } from '../../common/components/loading/loading.component';
import { MobileMenuComponent } from '../../common/components/mobile-menu/mobile-menu.component';
import { PopupFiltriRicercaComponent } from '../../common/components/popup-filtri-ricerca/popup-filtri-ricerca.component';
import { PopupComponent } from '../../common/components/popup/popup.component';
import {
  RichiesteGenerichePopupComponent
} from '../../common/components/richieste-generiche-popup/richieste-generiche-popup.component';
import {
  SearchBarInputComponent as SearchBarInputComponent_1
} from '../../common/components/search-bar-input/search-bar-input.component';
import Constants, { SearchQuery } from '../../utils/Constants';
import { RicercaSuMappaComponent } from '../ricerca-su-mappa/ricerca-su-mappa.component';

@Component({
  selector: 'app-ricerca',
  templateUrl: './ricerca.component.html',
  styleUrls: ['./ricerca.component.scss'],
  providers: [CurrencyPipe],
  animations: [
    trigger('slideIn', [
      state('open', style({
        bottom: 0
      })),
      state('close', style({
        bottom: -300
      })),
      transition('close => open', animate('400ms ease-in')),
      transition('open => close', animate('400ms ease-out')),
    ]),
  ],
  standalone: true,
  imports: [HeaderComponent, CardSearchAtecoComponent, SearchBarInputComponent_1, NgIf, RicercaSuMappaComponent, NgFor, CardSearchAnnuncioComponent, BrandBannerComponent, CardSearchAgenziaComponent, CardSearchAgenteComponent, CardSearchProfessionistaComponent, RouterLink, LoadingComponent, CardRicercheRecentiComponent, FooterComponent, PopupComponent, MobileMenuComponent, PopupFiltriRicercaComponent, RichiesteGenerichePopupComponent, SlicePipe]
})
export class RicercaComponent extends CommonComponent implements OnInit {
  modalIsOpen = false;

  isMobile: boolean;
  openGenReqPopup = false;
  handleViewBoxGenericReq: boolean;
  @ViewChild(SearchBarInputComponent) searchBarInput: SearchBarInputComponent;

  // RISULTATI DELLA RICERCA
  public searchResultsAnnuncio: ListingSearch;
  public searchResultsAgency: AgencySearch;
  public searchResultsAgent: AgentSearch;
  public searchResultsProfessionist: ProfessionistSearch;
  public userSearch: UserSearch;

  // MESSAGGIO PER LE RICERCHE SENZA FILTRI
  public retrySearchAnnunciMessage = false;
  public retrySearchAgencyMessage = false;
  public retrySearchProfessionistMessage = false;
  public retrySearchAgentMessage = false;

  // PRENDE LE DUE LISTE DI TIPOLOGIE
  listOfCompany: any = Constants.LIST_OF_COMPANY;
  listOfTypologies: any = Constants.LIST_OF_TYPOLOGY;

  // GESTIONE FILTRAGGIO
  public orderID = '';
  public idDropdownOpen = '';

  // GESTIONE PAGINAZIONE
  paginationRange = 3;
  limitPagination = 15;
  page = 0;
  ceilPagination = 1;

  // RICERCA SALVATA
  savedSearch = false;

  isShowingMap: boolean; // DECIDE SE MOSTRARE LA VISUALIZZAZIONE A MAPPA O LISTA
  switchPage: number; // SALVA PAGINA AL CAMBIO VIEW

  // PARAMETRI PER EFFETTUARE LA RICERCA
  searchValue = ''; // VALORE DI RICERCA
  searchType = ''; // TIPOLOGIA DI RICERCA: VENDITA, AFFITTO O AGENZIA
  searchPlaceholder = ''; // VALORE DI PLACEHOLDER
  searchCategoria: any; // SELEZIONA LA TIPOLOGIA DI IMMOBILE O LA COMPANY
  searchTimer: any;
  searchCoords: any;
  searchRadius: any;
  searchComune: string;
  searchProvincia: string;
  searchZona: string;
  searchRegione: string;
  searchURL: string;
  searchMethod: number;

  additionalFilters: any;

  // SALVA RICERCA FIXED
  showSaveSearch = false;
  hasBeenClosed = false;

  // VISITED LISTING
  visitedListing: any[] = [];
  finanziamentoConfig: MutuiConfig;
  title: string;
  shareAnnuncio: { url: string; title: string; description: string; };

  itemsMatchGenericRequest: any[] = [];

  searchInvalid = false;
  openMoreFiltersPopup = false;
  loadPopup = false;

  public showBoxServizi = false;

  public isAgentSelected = true;

  filterRemovedEvent = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    private authenticationService: AuthenticationService,
    private listings: ListingService,
    private route: ActivatedRoute,
    private router: Router,
    private memberService: MemberService,
    private userSearchAPI: UserSearchService,
    private genericRequestService: GenericRequestService,
    private toastr: ToastrService,
    private cp: CurrencyPipe,
    private agencyAPI: AgencyService,
    private agentAPI: AgentService,
    private professionistApi: ProfessionistService,
    public main: AppComponent,
    private titleService: Title,
    private meta: Meta,
    private console: ConsoleLoggerService,
    private shareService: ShareService,
    private cookieService: SsrCookieService,
    private metaService: Meta,
    @Optional() @Inject(RESPONSE) private response: Response
  ) {
    super(authenticationService);
  }

  async ngOnInit(): Promise<void> {
    console.log('INIT RICERCA')
    // check if the route is an old stile route
    if (isPlatformServer(this.platformId) && this.response && !this.response.headersSent) {
      const isOldRoute = this.main.checkIfOldRoute(this.router.url);
      if (isOldRoute) {
        this.response.redirect(301, this.main.generateNewUrl(this.router.url));
        this.response.end();
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      window.innerWidth > 550 ? this.isMobile = false : this.isMobile = true;
      window.innerWidth > 991 ? this.handleViewBoxGenericReq = false : this.handleViewBoxGenericReq = true;
    }

    this.isShowingMap = false;
    this.route.queryParams.subscribe(async (params: any) => {

      const r = this.router.url.includes('?') ?
        this.router.url.split('?')[0].split('/') :
        this.router.url.split('/');

      if (r.length === 0) {
        await this.router.navigate(['']);
      } else {
        // PRENDE I PARAMETRI DI RICERCA
        const obj = this.main.getParamsURL(this.router.url, params, 'vendita');
        this.searchRadius = obj.searchRadius;
        this.searchCoords = obj.searchCoords;
        this.searchCategoria = obj.searchCategoria;
        this.searchType = obj.searchType;
        this.main.searchType = obj.searchType;
        this.searchComune = obj.searchComune;
        this.searchPlaceholder = obj.searchPlaceholder;
        this.searchProvincia = obj.searchProvincia;
        this.searchZona = obj.searchZona;
        this.searchRegione = obj.searchRegione;
        this.searchValue = obj.searchValue;
        this.searchMethod = obj.searchMethod;
        this.main.orderList.order = obj.order;
        if (isPlatformBrowser(this.platformId)) {
          if (this.searchType === 'vendita' || this.searchType === 'affitto') {
            this.main.getLikedListing();
            this.main.getSavedListing();
          } else if (this.searchType === 'agenzia') {
            this.main.getLikedAgency();
            this.main.getFavouriteAgency();
          } else if (this.searchType === 'agente') {
            this.main.getLikedAgent();
            this.main.getFavouriteAgent();
          } else if (this.searchType === 'professionista') {
            this.main.getLikedProfessionists();
            this.main.getFavouriteProfessionists();
          }
        }

        if (this.searchType === 'vendita' || this.searchType === 'affitto') {
          this.setParamsForVenditaAndAffitto(params);
        } else if (this.searchType === 'agenzia') {
          console.log(`Siamo in agenzia`);
          this.setParamsForAgency(params);
        } else {
          this.setParamsForAgentAndProfessionist(params);
        }

        if (obj.activitiesOrder !== undefined) {
          this.main.orderList.activities = obj.activitiesOrder;
        }
        if (obj.order !== undefined) {
          this.main.orderList.order = obj.order;
        }

        // FORMATTO LE COORDINATE
        if (this.searchCoords) {
          if (!this.searchRadius && this.searchCoords.length !== 2) {
            let arrayOfNumbers;
            if (typeof this.searchCoords === 'string') {
              arrayOfNumbers = this.searchCoords.split(',');
            } else {
              arrayOfNumbers = this.searchCoords[0].split(',');
            }
            const coordinate = [];
            for (let i = 0; i < arrayOfNumbers.length; i++) {
              if (i % 2 === 0) {
                coordinate.push([
                  parseFloat(arrayOfNumbers[i]),
                  parseFloat(arrayOfNumbers[i + 1]),
                ]);
              }
            }
            delete this.searchCoords;

            this.searchCoords = coordinate;
          } else {
            this.searchCoords = this.searchCoords.map((num) => Number(num));
          }
        }

        // Gestione page prima della ricerca
        this.page = params.pagina ? (params.pagina - 1) : 0;

        if (this.searchType === 'vendita' || this.searchType === 'affitto') {
          await this.getResultsAnnunci();
        }
        if (this.searchType === 'agenzia') {
          await this.getResultsAgency();
        }
        if (this.searchType === 'agente') {
          await this.getResultsAgent();
        }
        if (this.searchType === 'professionista') {
          await this.getResultsProfessionist();
        }

        this.setPageTitle();
      }
    });

    if (this.isLogged) {
      if ((await this.main.getRicercheSalvate()).findIndex(a => a.frontEndObject.url === this.searchURL) !== -1) {
        this.savedSearch = true;
      }
    }
    setTimeout(() => {
      this.isAddress();
    }, 2000);

    if (!this.main?.isLogged) {
      this.main?.getVisitedListing().then(data => {
        lastValueFrom(this.listings.listingGetVisitedListing(JSON.stringify(data))).then(results => {
          this.visitedListing = [];
          data.forEach((id: string) => {
            if (results.filter(a => a.id === id)[0]) {
              this.visitedListing.push(results.filter(a => a.id === id)[0]);
            }
          });
          this.visitedListing.reverse();
          this.visitedListing = this.visitedListing.filter((l: Listing) => l.status !== 'suspended');
        }).catch(e => this.console.error(e));
      }).catch(e => this.console.error(e));
    } else {
      this.main?.getVisitedListing()
        .then((response) => {
          this.visitedListing = response.slice().reverse();
          this.visitedListing = this.visitedListing.filter((l: Listing) => l.status !== 'suspended');
        }).catch((e) => {
          this.console.error(e);
        });
    }
    this.setCanonicalTag(this.router.url);
  }

  private setParamsForVenditaAndAffitto(params: any): void {
    // PRENDE I PARAMETRI DI FILTRAGGIO DALL'URL
    if (params.con_prezzo_min) {
      this.main.filtersList.minPrice = params.con_prezzo_min;
    }
    if (params.con_prezzo_max) {
      this.main.filtersList.maxPrice = params.con_prezzo_max;
    }
    if (params.con_superficie_min) {
      this.main.filtersList.minMQ = params.con_superficie_min;
    }
    if (params.con_superficie_max) {
      this.main.filtersList.maxMQ = params.con_superficie_max;
    }
    if (params.con_locali_min) {
      this.main.filtersList.minLocali = params.con_locali_min;
    }
    if (params.con_locali_max) {
      this.main.filtersList.maxLocali = params.con_locali_max;
    }
    if (params.finanziamentoMin) {
      this.main.filtersList.maxFinanziamento = params.finanziamentoMin;
    }
    if (params.finanziamentoMax) {
      this.main.filtersList.minFinanziamento = params.finanziamentoMax;
    }
    if (params.condizioni) {
      this.main.filtersList.conditions = params.condizioni;
    }
    if (params.contesto) {
      this.main.filtersList.context = params.contesto;
    }
    if (params.extra) {
      this.main.filtersList.extra = params.extra;
    }
    if (params.piano) {
      this.main.filtersList.floors = params.piano;
    }
    if (params.garage) {
      this.main.filtersList.garage = params.garage;
    }
    if (params.giardino) {
      this.main.filtersList.garden = params.giardino;
    }
    if (params.riscaldamento) {
      this.main.filtersList.heating = params.riscaldamento;
    }
    if (params.asta_immobiliare) {
      this.main.filtersList.is_auction = params.asta_immobiliare;
    }
    if (params.con_cucina) {
      this.main.filtersList.kitchen = params.con_cucina;
    }
    if (params.con_bagni) {
      this.main.filtersList.bathrooms = parseInt(params.con_bagni, 10);
    }
    if (params.in_esclusiva) {
      this.main.filtersList.exclusive = params.in_esclusiva;
    }
  }

  private setParamsForAgency(params: any): void {
    if (params.associate) {
      this.main.filtersList.associations = params.associate;
    }
  }
  private setParamsForAgentAndProfessionist(params: any): void {
    const type = this.main.searchType === 'agente' ? 'agenti' : 'professionisti';
    // Only agent params
    if (params.agenti_con_incarico) {
      this.main.filtersList.mandates = params.agenti_con_incarico;
    }
    if (params.agenti_in_cerca_di_opportunita) {
      this.main.filtersList.opportunity = params.agenti_in_cerca_di_opportunita;
    }
    if (params.collaborazione_tra_agenti) {
      this.main.filtersList.collab = params.collaborazione_tra_agenti;
    }
    if (params.associati) {
      this.main.filtersList.associations = params.associati;
    }
    // Agent - Professionist params
    if (params[`${type}_specializzati_in`]) {
      this.main.filtersList.specializations = params[`${type}_specializzati_in`];
    }
    if (params[`${type}_che_parlano`]) {
      this.main.filtersList.languages = params[`${type}_che_parlano`];
    }
    if (params[`${type}_con_esperienza_minima`]) {
      this.main.filtersList.minExp = params[`${type}_con_esperienza_minima`];
    }
    if (params[`${type}_con_esperienza_massima`]) {
      this.main.filtersList.maxExp = params[`${type}_con_esperienza_massima`];
    }
  }

  private setPageTitle(): void {
    const pageTitle = this.titleHandler().replace(/  +/g, ' ');
    this.titleService.setTitle(pageTitle.replace(/^\d+\s*/, ''));
    const description = 'Scopri ' + pageTitle + ' Scopri i migliori professionisti dell\'immobiliare per cercare casa ed appartamenti in vendita e affitto.';
    this.meta.updateTag({ name: 'description', content: description });
    this.shareService.setFacebookTags(
      this.shareService.getActualRoute(), // url
      pageTitle, // title
      description,
      environment.sitePath + '/assets/img/share-logo.jpg'  // image
    );
  }

  private titleHandler(): string {
    let title: string;
    switch (this.searchType) {
      case 'agente': {
        title = `${this.searchResultsAgent?.totalPlusAtecoAgents} ${this.searchResultsAgent?.total !== 1 ? 'Agenti' : 'Agente'}`;
        if (this.searchResultsAgent?.totalPlusAtecoAgents === 0) {
          title = 'Agenti';
        }
        title += ' immobiliari';
        if (this.searchCategoria) {
          const objCategory = this.listOfCompany.filter((item) => this.searchCategoria === item.id);
          title += ' ' + objCategory[0].text;
        }
        if (this.main.filtersList.associations) {
          title += ' ' + this.main.filtersList.associations.join(', ').toUpperCase();
        }
        title += `${this.searchZona ? ' in zona' : this.searchComune ? ' a' : this.searchProvincia ? ' in provincia di' : this.searchRegione ? ' in' : this.searchMethod === 1 ? ' in' : ''}` +
          `${this.searchMethod === 2 ? ' entro' : ''}` +
          `${this.searchMethod === 1 ? ' ' + this.main.capitalizeFirstLetter(this.searchPlaceholder.split('•')[0].split(', Italia')[0].replace(/ [0-9]/g, '').replace(/[0-9]/g, '')) : this.searchMethod === 2 ? ' ' + this.searchPlaceholder.split('(Area vicino a te)')[0] : this.searchMethod === 3 ? this.searchPlaceholder.split('Zone selezionate:')[1] + ' ' : ''}`;

        if (this.main.orderList.activities) {
          title += ' esperti in ' + this.main.orderList.activities;
        }
        if (this.main.filtersList.specializations) {
          const listSpecializations = [];
          this.main.filtersList.specializations.forEach(element => {
            const objSpecializations = this.main.specializations.find((item) => element === item.id);
            listSpecializations.push(objSpecializations.name);
          });
          title += ' specializzati in: ' + listSpecializations.join(', ');
        }
        if (this.main.filtersList.opportunity) {
          title += ' in cerca di opportunità lavorative';
        }
        if (this.main.filtersList.collab) {
          title += ' aperto a collaborazioni tra agenti';
        }
        if (this.main.filtersList.mandates) {
          const listMandates = [];
          this.main.filtersList.mandates.forEach(element => {
            const objMandates = this.main.mandates.find((item) => element === item.id);
            listMandates.push(objMandates.name);
          });
          title += ' con mandato: ' + listMandates.join(', ');
        }
        if (this.main.filtersList.minExp && this.main.filtersList.maxExp) {
          title += ' da ' + this.main.filtersList.minExp + ' a ' + this.main.filtersList.maxExp + ' anni di esperienza';
        } else {
          if (this.main.filtersList.minExp) {
            title += ' con minimo ' + this.main.filtersList.minExp + ' anni di esperienza';
          }
          if (this.main.filtersList.maxExp) {
            title += ' con massimo ' + this.main.filtersList.maxExp + ' anni di esperienza';
          }
        }
        break;
      }
      case 'professionista': {
        title = `${this.searchResultsProfessionist?.total} ${this.searchResultsProfessionist?.total !== 1 ? 'Consulenti' : 'Consulente'}`;
        if (this.searchResultsProfessionist?.total === 0) {
          title = 'Consulenti';
        }
        title += ' del credito assicurativo ';

        if (this.main.filtersList.associations) {
          title += ' ' + this.main.filtersList.associations.join(', ').toUpperCase();
        }
        title += `${this.searchZona ? ' in zona' : this.searchComune ? ' a' : this.searchProvincia ? ' in provincia di' : this.searchRegione ? ' in' : this.searchMethod === 1 ? ' in' : ''}` +
          `${this.searchMethod === 2 ? ' entro' : ''}` +
          `${this.searchMethod === 1 ? ' ' + this.main.capitalizeFirstLetter(this.searchPlaceholder.split('•')[0].split(', Italia')[0].replace(/ [0-9]/g, '').replace(/[0-9]/g, '')) : this.searchMethod === 2 ? ' ' + this.searchPlaceholder.split('(Area vicino a te)')[0] : this.searchMethod === 3 ? this.searchPlaceholder.split('Zone selezionate:')[1] + ' ' : ''}`;

        if (this.main.orderList.activities) {
          title += ' esperti in ' + this.main.orderList.activities;
        }
        if (this.main.filtersList.specializations) {
          const listSpec = [];
          this.main.filtersList.specializations.forEach(element => {
            const objSpec = this.main.specializationsProfessionists.find((item) => element === item.id);
            listSpec.push(objSpec.name);
          });
          title += ' specializzati in: ' + listSpec.join(', ');
        }
        if (this.main.filtersList.minExp && this.main.filtersList.maxExp) {
          title += ' da ' + this.main.filtersList.minExp + ' a ' + this.main.filtersList.maxExp + ' anni di esperienza';
        } else {
          if (this.main.filtersList.minExp) {
            title += ' con minimo ' + this.main.filtersList.minExp + ' anni di esperienza';
          }
          if (this.main.filtersList.maxExp) {
            title += ' con massimo ' + this.main.filtersList.maxExp + ' anni di esperienza';
          }

          if (this.main.filtersList.languages) {
            title += ' che parlano ' + this.main.filtersList.languages;
          }
        }
        break;
      }
      case 'agenzia': {
        title = `${this.searchResultsAgency?.total} ${this.searchResultsAgency?.total !== 1 ? 'Agenzie' : 'Agenzia'}`;
        if (this.searchResultsAgency?.total === 0) {
          title = 'Agenzie';
        }
        title += ' immobiliari';
        if (this.searchCategoria) {
          const objCat = this.listOfCompany.filter((item) => this.searchCategoria === item.id);
          title += ' ' + objCat[0].text;
        }
        if (this.main.filtersList.associations) {
          title += ' ' + this.main.filtersList.associations.join(', ').toUpperCase();
        }
        title += `${this.searchZona ? ' in zona' : this.searchComune ? ' a' : this.searchProvincia ? ' in provincia di' : this.searchRegione ? ' in' : this.searchMethod === 1 ? ' in' : ''}` +
          `${this.searchMethod === 2 ? ' entro' : ''}` +
          `${this.searchMethod === 1 ? ' ' + this.main.capitalizeFirstLetter(this.searchPlaceholder.split('•')[0].split(', Italia')[0].replace(/ [0-9]/g, '').replace(/[0-9]/g, '')) : this.searchMethod === 2 ? ' ' + this.searchPlaceholder.split('(Area vicino a te)')[0] : this.searchMethod === 3 ? this.searchPlaceholder.split('Zone selezionate:')[1] + ' ' : ''}`;
        break;
      }
      default: {
        title = '';
        if (this.searchResultsAnnuncio.total > 0) {
          title = this.searchResultsAnnuncio.total.toString();
        }
        const labelLocali = this.showLocaliLabel(true);
        if (typeof labelLocali === 'undefined' || labelLocali === '') {
          // AGGIUNGI: LA CATEOGIRA
          title += ' ' + this.main.toTitleCase(this.getCategory());
        } else {
          // AGGIUNGI: MONOLOCALE, BILOCALE, TRILOCALE
          title += ' ' + labelLocali;
        }
        // AGGIUNGI LA ZONA GEOGRAFICA
        title += ' in ' + this.searchType + (this.searchZona ? ' in zona' : this.searchComune ? ' a' : this.searchProvincia ? ' in provincia di' : this.searchRegione ? ' in' : this.searchMethod === 1 ? ' in' : '') +
          (this.searchMethod === 2 ? ' entro' : '') +
          (this.searchMethod === 1 ? ' ' + this.main.capitalizeFirstLetter(this.searchPlaceholder.split('•')[0].split(', Italia')[0].replace(/ [0-9]/g, '').replace(/[0-9]/g, '')) : this.searchMethod === 2 ? ' ' + this.searchPlaceholder.split('(Area vicino a te)')[0] : this.searchMethod === 3 ? this.searchPlaceholder.split('Zone selezionate:')[1] + ' ' : '');

        // AGGIUNGI: PREZZO, METRI QUADRI
        title += this.showPriceLabel() + ' ' + this.showMQLabel();
        if (typeof labelLocali === 'undefined' || labelLocali === '') {
          title += ' ' + this.showLocaliLabel(false);
        }

        if (this.main.filtersList.conditions) {
          const listFilterConditions = this.main.filtersList.conditions;

          const listFilter = [];
          listFilterConditions.forEach(element => {
            const objFilter = Constants.FILTER_CONDITIONS.find((item) => element === item.value);
            if (objFilter) {
              listFilter.push(objFilter.filterName);
            }
          });
          title += ' in condizioni ' + listFilter.join(', ');
        }

        if (this.main.filtersList.floors) {
          let listFloors = this.main.filtersList.floors;
          if (typeof this.main.filtersList.floors === 'string') {
            listFloors = this.main.filtersList.floors;
          }
          const listFilterFloor = [];
          listFloors.forEach(element => {
            const objFlo = Constants.FILTER_FLOORS.find((item) => element === item.value);
            if (objFlo) {
              listFilterFloor.push(objFlo.filterName);
            }
          });
          title += ' al ' + listFilterFloor.join(', ');
        }

        if (this.main.filtersList.garden) {
          let listGarden = this.main.filtersList.garden;
          if (typeof this.main.filtersList.garden === 'string') {
            listGarden = this.main.filtersList.garden;
          }
          const listFilterGarden = [];
          listGarden.forEach(element => {
            const objGard = Constants.FILTER_GARDEN.find((item) => element === item.value);
            if (objGard) {
              listFilterGarden.push(objGard.filterName);
            }
          });
          title += ' con ' + listFilterGarden.join(', ');
        }

        if (this.main.filtersList.garage) {
          let listGarage = this.main.filtersList.garage;
          if (typeof this.main.filtersList.garage === 'string') {
            listGarage = this.main.filtersList.garage;
          }
          const listFilterGarage = [];
          listGarage.forEach(element => {
            const objGar = Constants.FILTER_GARAGE.find((item) => element === item.value);
            if (objGar) {
              listFilterGarage.push(objGar.filterName);
            }
          });
          title += listFilterGarage.join(', ');
        }

        if (this.main.filtersList.extra) {
          const listExtra = this.main.filtersList.extra;

          const listFilterExtra = [];
          listExtra.forEach(element => {
            const objExtr = Constants.FILTER_EXTRA.find((item) => element === item.value);
            if (objExtr) {
              listFilterExtra.push(objExtr.filterName);
            }
          });
          title += ' con ' + listFilterExtra.join(', ');
        }

        if (this.main.filtersList.kitchen) {
          let listKitchen = this.main.filtersList.kitchen;
          if (typeof this.main.filtersList.kitchen === 'string') {
            listKitchen = this.main.filtersList.kitchen;
          }
          const listFilterKitchen = [];
          listKitchen.forEach(element => {
            const objKitch = Constants.TYPE_KITCHEN_FILTER.find((item) => element === item.value);
            if (objKitch) {
              listFilterKitchen.push(objKitch.text);
            }
          });
          title += ' con cucina ' + listFilterKitchen.join(', ');
        }

        if (this.main.filtersList.heating) {
          let listHeating = this.main.filtersList.heating;
          if (typeof this.main.filtersList.heating === 'string') {
            listHeating = this.main.filtersList.heating;
          }
          const listFilterHeating = [];
          listHeating.forEach(element => {
            const objHeating = Constants.HEATING.find((item) => element === item.value);
            if (objHeating) {
              listFilterHeating.push(objHeating.text);
            }
          });
          title += ' con riscaldamento ' + listFilterHeating.join(', ');
        }

        if (this.main.filtersList.bathrooms) {
          title += ' con almeno ' + this.main.filtersList.bathrooms + ' bagni';
        }
      }
    }
    title += ' - Cercacasa.it';
    title = this.main.capitalizeFirstLetter(title.trim());
    return title;
  }

  private setCanonicalTag(url: string): void {
    const canonicalUrl = url.includes('&') ? url.split('?')[0] : url;
    const existingCanonical = this.metaService.getTag('rel="canonical"');
    if (existingCanonical) {
      this.metaService.removeTagElement(existingCanonical);
    }
    this.metaService.addTag({
      rel: 'canonical',
      href: environment.sitePath + canonicalUrl
    });
  }


  // **********************
  // **********************
  // FILTRI PER ANNUNCI IN VENDITA E AFFITTO
  // **********************
  // **********************

  // MOSTRA IL TESTO - PREZZO
  private showPriceLabel(): string {
    const max = this.main.filtersList.maxPrice ? new Intl.NumberFormat('it-IT', { maximumSignificantDigits: 3 }).format(this.main.filtersList.maxPrice) + ' euro' : '';
    const min = this.main.filtersList.minPrice ? new Intl.NumberFormat('it-IT', { maximumSignificantDigits: 3 }).format(this.main.filtersList.minPrice) + ' euro' : '';
    if (!min && !max) {
      return '';
    } else if (!min && max !== '') {
      return this.main?.searchType === 'affitto'
        ? 'fino a ' + max + ' al mese'
        : 'fino a ' + max;
    } else if (!max && min !== '') {
      return this.main?.searchType === 'affitto'
        ? ' a ' + min + ' al mese'
        : ' a ' + min;
    } else if (max === min) {
      return 'a ' + min;
    } else {
      return 'da ' + min + ' a ' + max;
    }
  }

  // MOSTRA IL TESTO - SUPERFICIE
  private showMQLabel(): string {
    const min = this.main.filtersList.minMQ;
    const max = this.main.filtersList.maxMQ;
    if (!min && !max) {
      return '';
    } else if (!min && max !== '') {
      return 'fino a ' + max + 'mq';
    } else if (!max && min !== '') {
      return 'da ' + min + 'mq';
    } else if (max === min) {
      return min + 'mq';
    } else {
      return 'da ' + min + 'mq a ' + max + 'mq';
    }
  }

  // MOSTRA IL TESTO - LOCALI
  private showLocaliLabel(oneWord: boolean): string {
    const min = this.main.filtersList.minLocali;
    const max = this.main.filtersList.maxLocali;
    if (!min && max && max !== '' && !oneWord) {
      return ' fino a ' + max + ' locali';
    } else if (!max && min && min !== '' && !oneWord) {
      return ' da ' + min + ' locali';
    } else if (max === min) {
      if (oneWord) {
        if (max === 1) {
          return 'monolocali';
        }
        if (max === 2) {
          return 'bilocali';
        }
        if (max === 3) {
          return 'trilocali';
        }
        if (max === 4) {
          return 'quadrilocali';
        }
        if (max === 5) {
          return 'pentalocali';
        }
      } else if (!oneWord && min) {
        return ' ' + min + ' locali';
      } else {
        return '';
      }
    } else {
      if (!oneWord) {
        return ' da ' + min + ' a ' + max + ' locali';
      } else {
        return '';
      }
    }
  }

  // **********************
  // **********************
  // RICERCA ANNUNCI IN VENDITA E AFFITTO
  // **********************
  // **********************
  private async getResultsAnnunci(filters?: any): Promise<void> {
    this.ceilPagination = 1;
    this.searchResultsAgency = null;
    this.searchResultsAgent = null;
    this.searchResultsProfessionist = null;
    this.searchResultsAnnuncio = null;

    if (typeof filters === 'undefined') {
      this.finanziamentoConfig = await this.main.getMutuiConfig();
    }

    try {
      if (typeof filters === 'undefined') {
        this.additionalFilters = this.main.returnFilter(this.finanziamentoConfig);
        if (this.searchCategoria) {
          const matchedMacroItem = this.listOfTypologies.find(item => item.id === this.searchCategoria);
          const categoryValues = matchedMacroItem
            ? matchedMacroItem.value.map(subItem => subItem.value)
            : this.searchCategoria.split(',');

          // check redundand category
          const categoryMapping = {
            appartamenti: ['appartamento', 'appartamenti-indipendenti'],
            attici: ['attico-mansarda'],
            'case-indipendenti': ['casa-indipendente'],
            ville: ['villini', 'villa-bifamiliare', 'villa-trifamiliare', 'villa-quadrifamiliare']
          };

          if (categoryValues) {
            Object.keys(categoryMapping).forEach(category => {
              if (categoryValues.includes(category)) {
                categoryValues.push(...categoryMapping[category]);
              }
            });
          }

          this.additionalFilters.push({
            typology: {
              inq: categoryValues,
            },
          });
        }
        this.additionalFilters.push({
          contract_type: this.searchType === 'vendita' ? 'buy' : 'rent',
        });
        this.retrySearchAnnunciMessage = false;
      } else {
        this.additionalFilters = filters;
        this.retrySearchAnnunciMessage = true;
      }

    } catch (e) {
      this.console.error(e);
      this.searchResultsAnnuncio = {
        total: 0,
        page: 0,
        limit: 10,
        listings: [],
        userSearch: null,
      };
      this.titleService.setTitle('Nessun risultato disponibile.');
    }

    if (this.page === 0) {
      this.searchURL = environment.sitePath + this.router.url;
    } // AGGIUNGE L'URL DELLA CHIAMATA ALLE RICERCHE RECENTI

    if (!this.isLogged) {
      this.updateRicercheRecenti();
    } // SALVO LA RICERCA IN LOCALSTORAGE SE L'UTENTE NON è LOGGATO

    if (
      typeof this.searchRegione !== 'undefined' ||
      typeof this.searchProvincia !== 'undefined' ||
      typeof this.searchComune !== 'undefined' ||
      typeof this.searchZona !== 'undefined' ||
      typeof JSON.stringify(this.searchCoords) !== 'undefined') {
      this.searchResultsAnnuncio = await lastValueFrom(this.listings
        .listingSearch(
          this.page,
          this.limitPagination,
          this.searchRegione,
          this.searchProvincia,
          this.searchComune,
          this.searchZona,
          JSON.stringify(this.searchCoords),
          this.searchRadius,
          JSON.stringify(this.additionalFilters),
          JSON.stringify(this.creatSearchQuery()),
          this.main.getActivity(this.main.orderList.activities) + this.main.getOrder(this.main.orderList.order),
          (typeof filters !== 'undefined') ? true : null
        ));
      if (this.searchResultsAnnuncio.userSearch) {
        this.userSearch = this.searchResultsAnnuncio.userSearch;
      }
      // RIPETO LA RICERCA SE NON CI SONO RISULTATI
      await this.retrySearchAnnunci();

      this.ceilPagination = Math.ceil(
        this.searchResultsAnnuncio.total / this.searchResultsAnnuncio.limit
      );

    } else {
      this.searchResultsAnnuncio = {
        total: 0,
        page: 0,
        limit: 10,
        listings: [],
        userSearch: null,
      };
      this.searchInvalid = true;
      this.titleService.setTitle('Nessun risultato disponibile.');
    }
  }

  async retrySearchAnnunci(): Promise<void> {
    try {
      if (this.searchResultsAnnuncio.listings.length === 0) {
        if (this.additionalFilters.length - 2 > -1) {
          this.additionalFilters.splice(this.additionalFilters.length - 2, 1);
          await this.getResultsAnnunci(this.additionalFilters);
        } else {
          this.retrySearchAnnunciMessage = false;
        }
      }
    } catch (error) {
      this.console.error('IMPOSSIBILE EFFETTUARE UNA RICERCA DI SUGGERIMENTO PER ANNUNCI');
    }
  }

  // **********************
  // **********************
  // RICERCA AGENZIE
  // **********************
  // **********************
  private async getResultsAgency(filters?: any): Promise<void> {
    this.searchResultsAnnuncio = null;
    this.searchResultsAgency = null;
    this.searchResultsAgent = null;
    this.searchResultsProfessionist = null;
    this.ceilPagination = 1;
    this.additionalFilters = [];
    try {
      if ((typeof filters === 'undefined')) {
        this.additionalFilters = this.main.returnFilter();
        if (this.searchCategoria) {
          this.additionalFilters.push({
            group: {
              inq: this.searchCategoria.split(','),
            },
          });
        }
        this.retrySearchAgencyMessage = false;
      } else {
        this.additionalFilters = filters;
        this.retrySearchAgencyMessage = true;
      }
    } catch (e: any) {
      this.console.error(e);
    }

    if (this.page === 0) {
      this.searchURL = environment.sitePath + this.router.url;
    } // AGGIUNGE L'URL DELLA CHIAMATA ALLE RICERCHE RECENTI

    if (!this.isLogged) {
      this.updateRicercheRecenti();
    } // SALVO LA RICERCA IN LOCALSTORAGE SE L'UTENTE NON è LOGGATO

    if (
      typeof this.searchRegione !== 'undefined' ||
      typeof this.searchProvincia !== 'undefined' ||
      typeof this.searchComune !== 'undefined' ||
      typeof this.searchZona !== 'undefined' ||
      typeof JSON.stringify(this.searchCoords) !== 'undefined') {
      this.searchResultsAgency = await lastValueFrom(this.agencyAPI
        .agencySearch(
          this.page,
          this.limitPagination,
          this.searchRegione,
          this.searchProvincia,
          this.searchComune,
          this.searchZona,
          JSON.stringify(this.searchCoords),
          this.searchRadius,
          JSON.stringify(this.additionalFilters),
          JSON.stringify(this.creatSearchQuery()),
          this.main.getActivity(this.main.orderList.activities) + this.main.getOrder(this.main.orderList.order),
          (typeof filters !== 'undefined') ? true : null
        ));

      if (this.searchResultsAgency.userSearch) {
        this.userSearch = this.searchResultsAgency.userSearch;
      }

      // RIPETO LA RICERCA SE NON CI SONO RISULTATI
      await this.retrySearchAgency();

      this.ceilPagination = Math.ceil(
        this.searchResultsAgency.total / this.searchResultsAgency.limit
      );
    } else {
      this.searchResultsAgency = {
        total: 0,
        page: 0,
        limit: 10,
        agencies: [],
      };
      this.searchInvalid = true;
      this.titleService.setTitle('Nessun risultato disponibile.');
    }
  }

  async retrySearchAgency(): Promise<void> {
    try {
      if (this.searchResultsAgency.agencies.length === 0) {
        if (this.additionalFilters.length - 1 > -1) {
          this.additionalFilters.splice(this.additionalFilters.length - 1, 1);
          await this.getResultsAgency(this.additionalFilters);
        } else {
          this.retrySearchAgencyMessage = false;
        }
      }
    } catch (error) {
      this.console.error('IMPOSSIBILE EFFETTUARE UNA RICERCA DI SUGGERIMENTO PER AGENCY');
    }
  }

  // **********************
  // **********************
  // RICERCA CONSULENTI
  // **********************
  // **********************
  private async getResultsProfessionist(filters?: any): Promise<void> {
    this.isAgentSelected = false;
    this.searchResultsAnnuncio = null;
    this.searchResultsAgency = null;
    this.searchResultsAgent = null;
    this.searchResultsProfessionist = null;
    this.ceilPagination = 1;
    this.additionalFilters = [];
    try {
      if ((typeof filters === 'undefined')) {
        this.additionalFilters = this.main.returnFilter();
        if (this.searchCategoria) {
          this.additionalFilters.push({
            group: {
              inq: this.searchCategoria.split(','),
            },
          });
        }
        this.retrySearchProfessionistMessage = false;
      } else {
        this.additionalFilters = filters;
        this.retrySearchProfessionistMessage = true;
      }
    } catch (e: any) {
      this.console.error(e);
    }

    if (this.page === 0) {
      this.searchURL = environment.sitePath + this.router.url;
    } // AGGIUNGE L'URL DELLA CHIAMATA ALLE RICERCHE RECENTI

    if (!this.isLogged) {
      this.updateRicercheRecenti();
    } // SALVO LA RICERCA IN LOCALSTORAGE SE L'UTENTE NON è LOGGATO
    if (
      typeof this.searchRegione !== 'undefined' ||
      typeof this.searchProvincia !== 'undefined' ||
      typeof this.searchComune !== 'undefined' ||
      typeof this.searchZona !== 'undefined' ||
      typeof JSON.stringify(this.searchCoords) !== 'undefined') {
      this.searchResultsProfessionist = await lastValueFrom(this.professionistApi
        .professionistSearch(
          this.page,
          this.limitPagination,
          this.searchRegione,
          this.searchProvincia,
          this.searchComune,
          this.searchZona,
          JSON.stringify(this.searchCoords),
          this.searchRadius,
          JSON.stringify(this.additionalFilters),
          JSON.stringify(this.creatSearchQuery()),
          this.main.getActivity(this.main.orderList.activities) + this.main.getOrder(this.main.orderList.order),
          (typeof filters !== 'undefined') ? true : null
        ));

      if (this.searchResultsProfessionist.userSearch) {
        this.userSearch = this.searchResultsProfessionist.userSearch;
      }

      await this.retrySearchProfessionist();

      this.ceilPagination = Math.ceil(
        this.searchResultsProfessionist.total / this.searchResultsProfessionist.limit
      );

    } else {
      this.searchResultsProfessionist = {
        total: 0,
        page: 0,
        limit: 10,
        professionists: []
      };
      this.searchInvalid = true;
      this.titleService.setTitle('Nessun risultato disponibile.');
    }
  }

  async retrySearchProfessionist(): Promise<void> {
    try {
      if (this.searchResultsProfessionist.professionists.length === 0) {
        if (this.additionalFilters.length - 1 > -1) {
          this.additionalFilters.splice(this.additionalFilters.length - 1, 1);
          await this.getResultsProfessionist(this.additionalFilters);
        } else {
          this.retrySearchProfessionistMessage = false;
        }
      }
    } catch (error) {
      this.console.error('IMPOSSIBILE EFFETTUARE UNA RICERCA DI SUGGERIMENTO PER PROFESSIONISTI');
    }
  }

  // **********************
  // **********************
  // RICERCA AGENTI
  // **********************
  // **********************
  private async getResultsAgent(filters?: any): Promise<void> {
    this.isAgentSelected = true;

    this.searchResultsAnnuncio = null;
    this.searchResultsAgency = null;
    this.searchResultsAgent = null;
    this.searchResultsProfessionist = null;
    this.ceilPagination = 1;
    this.additionalFilters = [];
    try {
      if ((typeof filters === 'undefined')) {
        this.additionalFilters = this.main.returnFilter();
        if (this.searchCategoria) {
          this.additionalFilters.push({
            group: {
              inq: this.searchCategoria.split(','),
            },
          });
        }
        this.retrySearchAgentMessage = false;
      } else {
        this.retrySearchAgentMessage = true;
        this.additionalFilters = filters;
      }
    } catch (e: any) {
      this.console.error(e);
    }

    if (this.page === 0) {
      this.searchURL = environment.sitePath + this.router.url;
    } // AGGIUNGE L'URL DELLA CHIAMATA ALLE RICERCHE RECENTI

    if (!this.isLogged) {
      this.updateRicercheRecenti();
    } // SALVO LA RICERCA IN LOCALSTORAGE SE L'UTENTE NON è LOGGATO
    if (
      typeof this.searchRegione !== 'undefined' ||
      typeof this.searchProvincia !== 'undefined' ||
      typeof this.searchComune !== 'undefined' ||
      typeof this.searchZona !== 'undefined' ||
      typeof JSON.stringify(this.searchCoords) !== 'undefined') {
      let activity = '';
      if (this.main.orderList.activities) {
        activity = this.main.orderList.activities.replace(/_/g, ' ');
      }
      this.searchResultsAgent = await lastValueFrom(this.agentAPI
        .agentSearch(
          this.page,
          this.limitPagination, // with 99 map works
          this.searchRegione,
          this.searchProvincia,
          this.searchComune,
          this.searchZona,
          JSON.stringify(this.searchCoords),
          this.searchRadius,
          JSON.stringify(this.additionalFilters),
          JSON.stringify(this.creatSearchQuery()),
          this.main.getActivity(activity) + this.main.getOrder(this.main.orderList.order),
          (typeof filters !== 'undefined') ? true : null
        ));
      if (this.searchResultsAgent.userSearch) {
        this.userSearch = this.searchResultsAgent.userSearch;
        if (activity && this.userSearch?.frontEndObject?.url) {
          this.userSearch.frontEndObject.url = this.insertActivityInFrontEndUrl(activity);
        }
      }
      await this.retrySearchAgent();
      this.ceilPagination = Math.ceil(
        this.searchResultsAgent.total / this.searchResultsAgent.limit
      );
    } else {
      this.searchResultsAgent = {
        total: 0,
        page: 0,
        limit: 10,
        agents: [],
      };
      this.searchInvalid = true;
      this.titleService.setTitle('Nessun risultato disponibile.');
    }
  }

  private insertActivityInFrontEndUrl(activity: string): string {
    const { url } = this.userSearch.frontEndObject;
    const [baseUrl, queryParams] = url.split('?');
    return `${baseUrl}/esperti_in_${activity.replace(/ /g, '_')}${queryParams ? '?' + queryParams : ''}`;
  }

  async retrySearchAgent(): Promise<void> {
    try {
      if (this.searchResultsAgent.agents.length === 0) {
        if (this.additionalFilters.length - 1 > -1) {
          this.additionalFilters.splice(this.additionalFilters.length - 1, 1);
          await this.getResultsAgent(this.additionalFilters);
        } else {
          this.retrySearchAgentMessage = false;
        }
      }
    } catch (error) {
      this.console.error('IMPOSSIBILE EFFETTUARE UNA RICERCA DI SUGGERIMENTO PER AGENTI');
    }
  }

  // SE NON SEI LOGGATO, AGGIUNGE LE RICERCHE EFFETTUATE IN LOCALSTORAGE
  private updateRicercheRecenti(): void {
    const ricercheRecenti =
      this.cookieService.get('ricercheRecenti') ?
        JSON.parse(this.cookieService.get('ricercheRecenti')) :
        [];

    const obj: UserSearch = {
      frontEndObject: this.creatSearchQuery(),
      name: this.searchPlaceholder,
      queryObject: {
        filters_req: JSON.stringify(this.main.returnFilter(this.finanziamentoConfig)),
      },
    };

    ricercheRecenti.push(obj);
    this.cookieService.set('ricercheRecenti', JSON.stringify(ricercheRecenti), {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      sameSite: 'Lax',
      secure: true
    });
  }

  // SALVA LA RICERCA NELL'ACCOUNT SE LOGGATO
  public saveSearches(): void {
    if (this.isLogged) {
      if (this.userSearch) {
        this.userSearch.saved = true;
        this.userSearchAPI.userSearchPrototypePatchAttributes(this.userSearch.id, this.userSearch).subscribe(
          (success) => {
            this.savedSearch = true;
            this.toastr.success('La ricerca è stata salvata all\'interno delle tue ricerche', 'Ricerca salvata');
          },
          (error) => {
            this.toastr.error(
              'Si è verificato un errore. Riprova più tardi!',
              'Errore salvataggio'
            );
          }
        );
      }
    } else {
      this.openPopup();
    }
  }

  // CREA L'OGGETO DELLA RICERCA
  public creatSearchQuery(): {} {
    const obj: SearchQuery = {};

    if (this.searchPlaceholder) {
      Object.assign(obj, { placeholder: this.searchPlaceholder });
    }
    if (this.searchCoords) {
      Object.assign(obj, { coords: this.searchCoords });
    }
    if (this.searchRadius) {
      Object.assign(obj, { raggio: this.searchRadius });
    }
    if (this.searchComune) {
      Object.assign(obj, { comune: this.searchComune });
    }
    if (this.searchProvincia) {
      Object.assign(obj, { provincia: this.searchProvincia });
    }
    if (this.searchZona) {
      Object.assign(obj, { zona: this.searchZona });
    }
    if (this.searchRegione) {
      Object.assign(obj, { regione: this.searchRegione });
    }
    if (this.searchMethod) {
      Object.assign(obj, { metodo: this.searchMethod });
    }
    if (this.searchValue) {
      Object.assign(obj, { value: this.searchValue });
    }
    if (this.searchCategoria) {
      Object.assign(obj, { categoria: this.searchCategoria });
    }
    if (this.searchType) {
      Object.assign(obj, { type: this.searchType });
    }
    if (this.searchURL) {
      Object.assign(obj, { url: this.searchURL });
    }

    return obj;
  }

  // ********************************************************************
  // ********************************************************************
  // ********************************************************************
  // GESTIONE DEL FILTRAGGIO
  // ********************************************************************
  // ********************************************************************
  // ********************************************************************

  // ORDINA LA LISTA DI ANNUNCI
  async orderListing(value): Promise<void> {
    if (this.orderID !== value) {
      this.orderID = value;
      if (this.searchType === 'vendita' || this.searchType === 'affitto') {
        await this.getResultsAnnunci();
      }
      if (this.searchType === 'agenzia') {
        await this.getResultsAgency();
      }
      if (this.searchType === 'agente') {
        await this.getResultsAgent();
      }
      this.main.orderList.order = this.orderID;
      let queryParams;
      this.route.queryParams.subscribe(routeQueryParams => {
        queryParams = routeQueryParams;
      });
      if (this.main.orderList.order !== '') {
        queryParams = {
          ...queryParams,
          ordine: this.main.orderList.order
        };
      } else {
        queryParams = {
          ...queryParams,
          ordine: null
        };
      }
      await this.router.navigate(
        [], {
        queryParams,
        queryParamsHandling: 'merge'
      }
      );
    }
  }

  // SE L'UTENTE CLICCA FUORI DAL DROPDOWN VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    let clickedInside = false;
    if (isPlatformBrowser(this.platformId)) {
      Array.prototype.forEach.call(
        document.getElementsByClassName('filtersAnnuncio'),
        (element) => {
          if (element.contains(target)) {
            clickedInside = true;
          }
        }
      );
    }
    if (!clickedInside) {
      this.idDropdownOpen = '';
    }
  }

  // go to visitingListing Page
  navigateToUserViditingListing(): void {
    this.router.navigate(['/utente-annunci'], {
      queryParams: {
        tab: 'annunci-visitati'
      },
    });
  }

  getCategory(): string {
    let value: string;
    try {
      if (this.searchCategoria) {
        const array = this.searchCategoria.split(',');
        value = array[0].replace(/-/g, ' ');
        if (array.length > 3) {
          value = 'immobili';
          const findImmobili = this.listOfTypologies.find((item1) => {
            const findCategory = item1.value.find((item2) => item2.value === array[0]);
            try {
              return findCategory.value;
            } catch (error) {
              return false;
            }
          });
          value = findImmobili.text;
        } else if (array[2]) {
          value = value + ', ' + array[1].replace(/-/g, ' ') + ' e ' + array[2].replace(/-/g, ' ');
        } else if (array[1]) {
          value = value + ' e ' + array[1].replace(/-/g, ' ');
        } else {
          value = 'Case';
          try {
            this.listOfTypologies.map((item1) => {
              const findCase = item1.value.find((item2) => item2.value.toLowerCase() === array[0].toLowerCase());
              if (findCase && findCase.text) {
                value = findCase.text;
              }
            });
          } catch (error) {
            value = 'Case';
          }
        }
      } else {
        value = 'Immobili';
      }
    } catch (error) {
      value = 'Case';
    }
    return value;
  }

  getPlaceholder(): string {
    let value: string;
    // tslint:disable-next-line: triple-equals
    if (this.searchMethod === 1 && this.searchPlaceholder) {
      // Ricerca per comune
      value = this.searchPlaceholder
        .replace(/ *\([^)]*\) */g, '')
        .replace('•', '');
    }
    // tslint:disable-next-line: triple-equals
    if (this.searchMethod === 2 && this.searchPlaceholder) {
      // Ricerca vicino a me
      value = 'entro ' + this.searchPlaceholder;
    }
    // tslint:disable-next-line: triple-equals
    if (this.searchMethod === 3 && this.searchPlaceholder) {
      // Ricerca zona su mappa
      value = this.searchPlaceholder;
    }
    // tslint:disable-next-line: triple-equals
    if (this.searchMethod === 4 && this.searchPlaceholder) {
      // Ricerca disegno su mappa
      value = this.searchPlaceholder;
    }
    return value;
  }

  openPopup(): void {
    this.modalIsOpen = true;
  }

  closePopup(): void {
    this.modalIsOpen = false;
  }

  // ASCOLTA SCROLLING
  closeSaveSearch(): void {
    this.hasBeenClosed = true;
    this.showSaveSearch = false;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    const pos = document.documentElement.scrollTop;
    const el = document.querySelector('.renderList') as HTMLElement;
    const max = el.offsetTop;
    if (pos >= max) {
      if (!this.hasBeenClosed && !this.isShowingMap) {
        this.showSaveSearch = true;
      }
    }
  }

  getOrderFilters(): any[] {
    switch (this.searchType) {
      case 'professionista': {
        return this.main.orderFilters.filter(a => a.type === 'professionist');
      }
      case 'agente': {
        return this.main.orderFilters.filter(a => a.type === 'agent');
      }
      case 'agenzia': {
        return this.main.orderFilters.filter(a => a.type === 'agency');
      }
      default: {
        return this.main.orderFilters.filter(a => a.type === 'listing');
      }
    }
  }

  // MAP VIEW
  async changeView(): Promise<void> {
    this.isShowingMap = !this.isShowingMap;
    if (this.isShowingMap) {
      this.showSaveSearch = false;
    }

    // COPY AND RESET ALL VALUES
    if (this.isShowingMap) {
      this.switchPage = this.page;
      // ASSING MAP NEEDED VALUES
      this.page = 0;
      this.limitPagination = 1000;
      this.limitPagination = 15;
    } else {
      this.page = this.switchPage;
      this.limitPagination = 15;
    }

    // RELOAD PAGE IF RETURN FROM MAP
    if (!this.isShowingMap && (this.main.oldUrlSearchPage !== this.main.newUrlSearchPage) && (this.searchType === 'agente' || this.searchType === 'professionista')) {
      window.location.reload();
    }

    // GET RESULTS
    switch (this.searchType) {
      case 'vendita':
        await this.getResultsAnnunci();
        break;
      case 'agenzia':
        await this.getResultsAgency();
        break;
      case 'agente':
        await this.getResultsAgent();
        break;
      case 'professionista':
        await this.getResultsProfessionist();
        break;
      default:
        break;
    }
  }

  changeFromChild(isShowing: boolean): void {
    this.isShowingMap = isShowing;
  }

  // Se è una via, la centro su mappa
  isAddress(): [] | undefined {
    if (this.searchCoords && this.searchCoords.length === 2 && this.searchRadius === undefined) {
      return this.searchCoords;
    } else {
      return undefined;
    }
  }

  // IN LISTING PAGINATION
  getInListingObj(i: number): {
    position?: number,
    regione?: string,
    provincia?: string,
    comune?: string,
    zona?: string,
    coords?: string,
    radius?: number,
    filters?: string,
    order?: string,
  } {
    return {
      position: i,
      regione: this.searchRegione,
      provincia: this.searchProvincia,
      comune: this.searchComune,
      zona: this.searchZona,
      coords: JSON.stringify(this.searchCoords),
      radius: this.searchRadius,
      filters: JSON.stringify(this.additionalFilters),
      order: this.main.getActivity(this.main.orderList.activities) + this.main.getOrder(this.main.orderList.order)
    };
  }

  handleGenericRequest(): any {
    if (this.isLogged) {
      this.openGenReqPopup = true;
    } else {
      this.modalIsOpen = true;
    }
  }

  // SEND GENERIC REQUEST TO THE AGENCIES
  async submitGenericRequest(message: any): Promise<void> {
    this.loadPopup = true;

    const data: any = {
      regione: this.searchRegione,
      provincia: this.searchProvincia,
      comune: this.searchComune,
      zona: this.searchZona,
      coords_req: JSON.stringify(this.searchCoords),
      radius_req: this.searchRadius,
      queryObject: this.creatSearchQuery(),
      url: this.searchURL,
      text: message,
      first_name: this.currentUser.first_name,
      last_name: this.currentUser.last_name,
      phone_number: this.currentUser.phone_number,
      email: this.currentUser.email,
    };

    try {
      await lastValueFrom(this.genericRequestService.genericRequestCreateMultipleGenericRequests(data));
      this.toastr.success(
        'La tua richiesta è stata inviata con successo',
        'Ricerca Inviata'
      );
      this.loadPopup = false;
      this.openGenReqPopup = false;
    } catch (e) {
      this.console.error(e);
      this.toastr.error(
        'Si è verificato un errore. Riprova più tardi!',
        'Errore invio richiesta'
      );
      this.loadPopup = false;
      this.openGenReqPopup = false;
    }
  }


  // OPEN POPUP MORE FILTERS
  closeMoreFilterPopup(): void {
    this.openMoreFiltersPopup = false;
  }

  changeFiltersFromPopup(obj): void {
    for (const key in obj) {
      if (this.main.filtersList.hasOwnProperty(key)) {
        this.main.filtersList[key] = null;
        if (typeof obj[key] !== 'undefined') {
          this.main.filtersList[key] = obj[key];
        }
      }
    }
    this.searchBarInput.applySearch();
  }

  createAgentLabel(): string {
    if (this.searchRegione) {
      return `della regione ${this.searchRegione.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
    }
    if (this.searchProvincia) {
      return `della provincia di ${this.searchProvincia.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
    }
    if (this.searchComune) {
      return `di ${this.searchComune.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`;
    }
    if (this.searchZona) {
      return `della zona ${this.searchZona.charAt(0).toUpperCase() + this.searchZona.slice(1)}`;
    }
    if (this.searchValue) {
      return `della zona di ${this.searchValue.split(',')[0]}`;
    }
    return 'della zona';
  }

  selectFilter(type: string): any {
    let urlPathArray;
    let newUrl;

    this.main.resetSearchFilter();

    if (type === 'agente') {
      if (this.searchType !== 'agente') {
        this.isAgentSelected = true;
        urlPathArray = this.router.url.split('?')[0].replace('professionista', 'agente');
      }
    } else {
      if (this.searchType !== 'professionista') {
        this.isAgentSelected = false;
        urlPathArray = this.router.url.split('?')[0].replace('agente', 'professionista');
      }
    }

    newUrl = urlPathArray.split('/')[1] + '/' + urlPathArray.split('/')[2];
    this.router.navigateByUrl(newUrl);
  }

  public async resetFilterFromSearchBar() {
    this.filterRemovedEvent.emit();
  }
}
